export default "__VITE_ASSET__CbTEUXIY__"